import type { YomiriSearchFilter } from '../types/extension.ts';
import type { YomiriHttpClient } from '../network/types.ts';

/** Read only filters actually exposed by the source's search form. */
export async function discoverSearchFilters(sourceId: string, baseUrl: string, template: string,
  http: Pick<YomiriHttpClient, 'text'>): Promise<YomiriSearchFilter[]> {
  if (!['Madara', 'LeerCapitulo'].includes(template)) return [];
  const path = template === 'Madara' ? '/?s=&post_type=wp-manga' : '/manga/';
  const response = await http.text({ sourceId, url: new URL(path, baseUrl).href, method: 'GET',
    responseType: 'text', credentials: 'include', cache: { ttlMs: 600000, scope: 'session' } });
  if (response.status >= 400 || response.classification === 'challenge') throw new Error('No se pudieron obtener los filtros de la fuente.');
  const dom = new DOMParser().parseFromString(response.body, 'text/html');
  const candidates = template === 'Madara'
    ? [['genre[]', 'Categoría'], ['status[]', 'Estado'], ['m_orderby', 'Orden']]
    : [['genre', 'Género'], ['sort', 'Orden']];
  return candidates.flatMap(([key, label]) => {
    const controls = Array.from(dom.getElementsByName(key));
    const options = controls.flatMap(control => {
      if (control instanceof HTMLSelectElement) return Array.from(control.options).filter(o => o.value)
        .map(o => ({ value: o.value.startsWith('/') ? new URL(o.value, baseUrl).searchParams.get(key) ?? '' : o.value, label: o.textContent?.trim() ?? o.value }));
      if (control instanceof HTMLInputElement && control.value) {
        const text = control.labels?.[0]?.textContent?.trim();
        return text ? [{ value: control.value, label: text }] : [];
      }
      return [];
    }).filter(option => option.value);
    return options.length ? [{ key, label, options: [...new Map(options.map(o => [o.value, o])).values()] }] : [];
  });
}
